import type { Reroute } from "@sveltejs/kit";

/**
 * Paths that show another route's page, as in the React router: the email sign-in link and Apple's
 * redirect (both also open the Android app) land on the login page.
 */
const ALIASES = new Map([
  ["/signin-link", "/"],
  ["/apple-auth/callback", "/"],
]);

/**
 * Routes match whatever the case, as they did in the React router: the app links to both
 * /signup/accountinfo and /signup/accountInfo. The address bar keeps the URL as it was.
 */
export const reroute: Reroute = ({ url }) => {
  const path = url.pathname.toLowerCase();
  return ALIASES.get(path.replace(/(.)\/+$/, "$1")) ?? path;
};
